import { asks } from 'fp-ts/lib/Reader';
import { map, shareReplay, startWith } from 'rxjs/operators';
import { filterSuccess } from '../utils/object.utils';
import { getProductTeam } from './teams.service';
export var productsViewModel = asks(function (ctx) {
    var teamsService = ctx.teamsService;
    return {
        isPersonalOrSharedProduct$: teamsService.teams$.pipe(filterSuccess, startWith([]), map(function (teams) { return function (product) {
            return !getProductTeam(product).exists(function (teamId) { return teams.some(function (t) { return t.id === teamId; }); });
        }; }), shareReplay(1)),
    };
});
//# sourceMappingURL=products.view-model.js.map